import { render, staticRenderFns } from "./NftHistory.vue?vue&type=template&id=0ac18ab0&scoped=true&"
import script from "./NftHistory.vue?vue&type=script&lang=js&"
export * from "./NftHistory.vue?vue&type=script&lang=js&"
import style0 from "./NftHistory.vue?vue&type=style&index=0&id=0ac18ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac18ab0",
  null
  
)

export default component.exports